export const averageOpensTooltip =
  "Measured off the number of articles clicked, modules scrolled too.";

export const clickRateTooltip =
  "The % rate the main call to action button is clicked by the recipients to proposals sent, who want to take the next step.";

export const addionalFilterTooltip = "Show Filters";